import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../../store/actions/employeeActions';
import { LockOpenIcon, MagnifyingGlassIcon, UserCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";

const MFAStatusModal = ({
    modalStatus,
    closeModal,
    employee,
    resetMFA
}) => {

    if (!modalStatus) return null
    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
            <div className="modal-dialog" style={{ width: "40%" }}>
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20, position: 'sticky', top: 0, zIndex: 50 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={closeModal}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">MFA Status</h3>
                        </div>

                        <div className="block-content" style={{ margin: 20 }}>

                            <div className="col-sm-6">
                                MFA Status: {employee?.hasMFA ? 'Activated' : 'Pending'}
                            </div>

                            <div
                                className="pull-right btn btn-danger"
                                onClick={() => resetMFA(employee?.id)}
                            >
                                <LockOpenIcon style={{ height: "1.5em", float: "left" }} />
                                <div style={{ float: "left" }}>Reset MFA</div>
                            </div>

                            <div className="clearfix"></div>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {

    return {
        modalStatus: state.employee?.mfaStatusModal,
        employee: state.employee?.agreementInfo
    }
}
const mapDispatchToProps = dispatch => ({
    resetMFA: (agreement) => dispatch(ACTIONS.resetMFA(agreement)),
    closeModal: () => dispatch(ACTIONS.mfaStatusModal()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MFAStatusModal) 
